import { initConfetti, destroyConfetti } from '../initConfetti';

const getIconName = (type) => {
  if (type === 'Kickoff') {
    return 'icon-announcement';
  }
  if (type === 'Pass_success') {
    return 'icon-info';
  }
  if (['Goal', 'Free_kick_hit', 'Goal_with_assist', 'Penalty_successful'].includes(type)) {
    return 'icon-ball-green';
  } else if(['Penalty_missed'].includes(type)){
    return 'icon-ball-red';
  }
  return 'icon-announcement';
}

const getHighlightsIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red') {
    return '<i class="icon-red-card"></i>';
  }
  if (['Goal', 'Goal_with_assist', 'Free_kick_hit', 'Penalty_successful', 'Penalty_missed'].includes(type)) {
    return goals;
  }
  return type;
}

const getHighlightsOnlyIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<span class="pointer"></span><i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red' || type === 'Card_yellow_red') {
      return '<span class="pointer"></span><i class="icon-red-card"></i>';
  }
  if (['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(type)) {
      return '<span class="pointer"></span><i class="icon-ball-green"></i>';
  }
  return type;
}

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

function getLastReport(report) {
  if (report.length) {
    const d = report[0];
    return d;
  }
  return null;
}

function whoHasTheBall(report) {
  if (report.length) {
    const d = report[0];
    return lastReport.active_home === '1' ? 'home' : 'guest';
  }
  return 'home';
}

function whereHasTheBall(report, nft_id) {
  const playerids = report?.playerids?.split(';') || [];
  return nft_id === playerids[1] ? 'fade-in' : 'fade-out';
}

export default ({ guestTeamData, homeTeamData, report, isCompleted = '1' }) => {
  // const status = whoHasTheBall(report);
  const lastReport = getLastReport(report);
  const playerids = lastReport?.playerids?.split(';') || [];

  if (lastReport.active_home === '1') {
    $('.lineups__team.home').addClass('active animate-right');
    $('.lineups__team.guest').removeClass('active animate-right');
  } else {
    $('.lineups__team.guest').addClass('active animate-right');
    $('.lineups__team.home').removeClass('active animate-right');
  }

  if (['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(lastReport.actiontype)) {
    initConfetti();
    $('.lineups__team.guest').removeClass('active animate-right');
    $('.lineups__team.home').removeClass('active animate-right');
    $('.js-ball-item').removeClass('fade-in').addClass('fade-out');

    setTimeout(() => {
      destroyConfetti();
    }, 6000);
  } else {
    $('.js-ball-item').removeClass('fade-in').addClass('fade-out');
    $(`.js-ball-item[data-nft-id="${playerids[0]}"]`).addClass('fade-in').removeClass('fade-out');
    $(`.js-ball-item[data-nft-id="${playerids[1]}"]`).addClass('fade-in').removeClass('fade-out');

    setTimeout(() => {
      $(`.js-ball-item[data-nft-id="${playerids[0]}"]`).addClass('fade-out').removeClass('fade-in');
    }, 300);
  }
};
